import React from "react";

const StatsBar = () => {
  return (
    <>
    <div className="container">
      <div className="stats-grid">
        <div className="item">
          <span className="icon">⭐</span>
          <div>
            <strong>Google</strong>
            <p>Reviews 5.0/5</p>
          </div>
        </div>

        <div className="item">
          <span className="icon">🏅</span>
          <div>
            <strong>Laser</strong>
            <p>Approved Technology</p>
          </div>
        </div>

        <div className="item">
          <span className="icon">👨‍👩‍👧‍👦</span>
          <div>
            <strong>2,000+</strong>
            <p>Happy Patients</p>
          </div>
        </div>

        <div className="item">
          <span className="icon">👨‍⚕️</span>
          <div>
            <strong>Team of</strong>
            <p>Expert Doctors</p>
          </div>
        </div>
      </div>
      </div>

      <style>{`
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          background: #f1e3ce;
          border-radius: 10px;
          overflow: hidden;
        }

        .item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 15px;
          border-right: 1px solid #faf7f7;
        }

        .item:nth-child(4) {
          border-right: none;
        }

        .icon {
          font-size: 22px;
          color: #d4a017;
        }

        /* 🔥 Mobile Fix */
        @media (max-width: 768px) {
          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .item {
            border-right: none;
            border-bottom: 1px solid #ffffff;
          }

          .item:nth-child(odd) {
            border-right: 1px solid #faf5f5;
          }

          .item:nth-child(3),
          .item:nth-child(4) {
            border-bottom: none;
          }
        }
      `}</style>
    </>
  );
};

export default StatsBar;